import { useEffect, useRef } from "react";
import { env } from "./env";
import { getAccessToken } from "./api";

export type FlatEvent = {
  type: string;
  flatId: string;
  userId?: string;
  title?: string;
  message?: string;
  url?: string;
};

/**
 * Hold open a single SSE connection to /events and hand each event to `onEvent`.
 * EventSource gives us reconnect-with-backoff for free; we recreate it if the
 * access token changes. Enabled is false when signed out.
 */
export function useEvents(enabled: boolean, onEvent: (event: FlatEvent) => void): void {
  const handlerRef = useRef(onEvent);
  handlerRef.current = onEvent;

  useEffect(() => {
    if (!enabled) return;
    const token = getAccessToken();
    if (!token) return;

    const url = `${env.VITE_API_URL}/events?token=${encodeURIComponent(token)}`;
    const es = new EventSource(url);

    es.addEventListener("message", (e) => {
      try {
        handlerRef.current(JSON.parse((e as MessageEvent).data) as FlatEvent);
      } catch {
        /* ignore malformed */
      }
    });

    // Let EventSource retry on transient errors; nothing to do here.
    es.addEventListener("error", () => {});

    return () => es.close();
    // Reconnect when auth flips.
  }, [enabled]);
}
